import React from "react";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryLabel,
  VictoryGroup,
} from "victory";

export default function BarChart(props) {
  const { data, colors } = props;
  var barcount = 0;
  data.map(() => {
    barcount++;
  });
  return (
    <div>
      <VictoryChart width={450} height={350}>
        <VictoryGroup colorScale={colors}>
          {data.map((d, i) => {
            return (
              <VictoryBar
                key={i}
                data={[d]}
                labels={[`${d.y}%`]}
                labelComponent={
                  <VictoryLabel
                    inline
                    style={[{ fill: "black" }]}
                    verticalAnchor={"middle"}
                    dy={-10}
                  />
                }
                barWidth={450 / barcount - 15}
                cornerRadius={{
                  topLeft: 10,
                  topRight: 10,
                  bottomLeft: 10,
                  bottomRight: 10,
                }}
              />
            );
          })}
        </VictoryGroup>
        <VictoryAxis
          crossAxis={false}
          style={{
            tickLabels: {
              fontSize: 13,
              fill: "black",
            },
            axis: { stroke: "none" },
          }}
        />
      </VictoryChart>
    </div>
  );
}
